// extracted by mini-css-extract-plugin
export default {"main":"brands_main__I8H40","brands":"brands_brands__AyPkF","brand":"brands_brand__VHEHa"};